import p from "./index47.js";
import { isString as g } from "./index125.js";
import c from "./index127.js";
import u from "./index46.js";
class r {
  /** */
  constructor(t, s) {
    t === void 0 && (t = []), s === void 0 && (s = 0), this.chunks = t, this.from = s;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(t) {
    if (!String(t))
      return;
    t = g(t) ? new c(String(t)) : t;
    const s = this.chunks[this.chunks.length - 1], n = s && // if stops are same or tail has no stop
    (s.stop === t.stop || t.stop == null) && // if tail chunk goes just after last chunk
    t.from === s.from + s.toString().length;
    if (t instanceof c)
      n ? s.extend(t.toString()) : this.chunks.push(t);
    else if (t instanceof r) {
      if (t.stop == null) {
        let e;
        for (; t.chunks.length && t.chunks[0].stop == null; )
          e = t.chunks.shift(), e.from += t.from, this.extend(e);
      }
      t.toString() && (t.stop = t.blockIndex, this.chunks.push(t));
    }
  }
  appendTo(t) {
    if (!(t instanceof u.MaskedPattern))
      return new c(this.toString()).appendTo(t);
    const s = new p();
    for (let n = 0; n < this.chunks.length; ++n) {
      const e = this.chunks[n], i = t._mapPosToBlock(t.displayValue.length), o = e.stop;
      let h;
      if (o != null && // if block not found or stop is behind lastBlock
      (!i || i.index <= o) && ((e instanceof r || // for continuous block also check if stop is exist
      t._stops.indexOf(o) >= 0) && s.aggregate(t._appendPlaceholder(o)), h = e instanceof r && t._blocks[o]), h) {
        const f = h.appendTail(e);
        s.aggregate(f);
        const l = e.toString().slice(f.rawInserted.length);
        l && s.aggregate(t.append(l, {
          tail: !0
        }));
      } else
        s.aggregate(t.append(e.toString(), {
          tail: !0
        }));
    }
    return s;
  }
  get state() {
    return {
      chunks: this.chunks.map((t) => t.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(t) {
    const {
      chunks: s,
      ...n
    } = t;
    Object.assign(this, n), this.chunks = s.map((e) => {
      const i = "chunks" in e ? new r() : new c();
      return i.state = e, i;
    });
  }
  unshift(t) {
    if (!this.chunks.length || t != null && this.from >= t)
      return "";
    const s = t != null ? t - this.from : t;
    let n = 0;
    for (; n < this.chunks.length; ) {
      const e = this.chunks[n], i = e.unshift(s);
      if (e.toString()) {
        if (!i)
          break;
        ++n;
      } else
        this.chunks.splice(n, 1);
      if (i)
        return i;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length)
      return "";
    let t = this.chunks.length - 1;
    for (; 0 <= t; ) {
      const s = this.chunks[t], n = s.shift();
      if (s.toString()) {
        if (!n)
          break;
        --t;
      } else
        this.chunks.splice(t, 1);
      if (n)
        return n;
    }
    return "";
  }
}
export {
  r as default
};
